import { IconPlus } from "@tabler/icons-react"
import { Button, DataFetchWrapper, SectionHeader } from "@tfg/ui"
import { useState } from "react"
import { useTranslation } from "react-i18next"

import { ProductionSiteTable } from "~/pages/SupplierPortal/ProductionSites/components/ProductionSiteTable.tsx"
import { useListSupplierProductionSitesQuery } from "~/pages/SupplierPortal/ProductionSites/hooks/useListProductionSiteQuery.ts"
import { ProductionSiteDrawer } from "~/pages/SupplierPortal/TraceabilityRequests/components/ProductionSiteDrawer.tsx"

export const SupplierProductionSites = () => {
  const productionSitesQuery = useListSupplierProductionSitesQuery()
  const [modalOpened, setModalOpened] = useState(false)
  const { t } = useTranslation(["supplier"])

  return (
    <>
      <SectionHeader
        mainCta={
          <Button icon={<IconPlus />} onClick={() => setModalOpened(true)}>
            {t("productionSites.buttons.add")}
          </Button>
        }
      />
      <DataFetchWrapper query={productionSitesQuery}>
        {({ data }) => <ProductionSiteTable productionSites={data} />}
      </DataFetchWrapper>
      <ProductionSiteDrawer
        defaultName=""
        opened={modalOpened}
        onClose={() => setModalOpened(false)}
        onProductionSiteCreated={() => setModalOpened(false)}
      />
    </>
  )
}
